import CommonFacilityFields from './CommonFacilityFields';

export default CommonFacilityFields;
